import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import { SCREEN_LABELS, bannersPath } from "./bannerPaths";

export default function SectionTrail({ placement, section, franchiseId }) {
  const steps = [
    { title: "Home banners", to: bannersPath({ franchiseId }) },
    { title: SCREEN_LABELS[placement.screen], to: bannersPath({ screen: placement.screen, franchiseId }) },
    { title: placement.label, to: bannersPath({ screen: placement.screen, placement: placement.id, franchiseId }) },
  ];
  return (
    <Breadcrumb
      className="mb-3"
      items={[...steps.map(({ title, to }) => ({ title: <Link to={to}>{title}</Link> })), { title: section.title }]}
    />
  );
}
